<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "CompanyFulfillmentsOmsAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  